import React, { useEffect, useRef } from 'react';
import { XTerm } from 'xterm-for-react';
import useLog from '../../useLog';

export default function ({ host }) {
  const xtermRef = useRef(null);
  const { lastLog } = useLog(host);

  useEffect(() => {
    if (lastLog) {
      let { msg } = lastLog;
      if (Array.isArray(msg)) {
        msg = msg[0];
      }
      xtermRef.current.terminal.writeln(msg);
    }
  }, [lastLog]);

  return (
    <>
      <XTerm ref={xtermRef} />
    </>
  );
}
